import { render, staticRenderFns } from "./PWProduct.vue?vue&type=template&id=6b077f76&"
import script from "./PWProduct.vue?vue&type=script&lang=js&"
export * from "./PWProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports